// extracted by mini-css-extract-plugin
module.exports = {"wizardStepIcon":"wizard-sidebar-ribbon-hashed__wizardStepIcon__3uZjh"};